import { z } from 'zod';
/** A field the firm may leave empty: `null` or an empty text, both kept as none. */
export const optionalText = (max) => z.string().trim().max(max).nullable();
/** A postal address as the firm types it - each part optional (after Corly's address fields). */
export const addressInputShape = {
    street: optionalText(120),
    postalCode: optionalText(10),
    city: optionalText(80),
    /** ISO 3166-1 alpha-2, e.g. `DE`; `null`: not stated. */
    countryCode: z
        .string()
        .regex(/^[A-Z]{2}$/)
        .nullable(),
};
/** A postal address as it is kept: each part `null` where not stated. */
export const addressShape = {
    street: z.string().nullable(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    countryCode: z.string().nullable(),
};
//# sourceMappingURL=address.js.map